export interface CourseGrades {
  id: string;
  name: string;
  short: string;
  enrolled: number;
  pre: number;
  post: number;
  final: number;
  completionPct: number;
  hoursAvg: number;
  npsScore: number;
}

const MBA_COURSES: CourseGrades[] = [
  {
    id: 'c1',
    name: 'Strategic Management',
    short: 'Strategy',
    enrolled: 24,
    pre: 58,
    post: 78,
    final: 82,
    completionPct: 96,
    hoursAvg: 38,
    npsScore: 62,
  },
  {
    id: 'c2',
    name: 'Corporate Finance',
    short: 'Finance',
    enrolled: 24,
    pre: 54,
    post: 71,
    final: 75,
    completionPct: 88,
    hoursAvg: 42,
    npsScore: 41,
  },
  {
    id: 'c3',
    name: 'Decision Science',
    short: 'Decision Sci.',
    enrolled: 24,
    pre: 61,
    post: 80,
    final: 84,
    completionPct: 92,
    hoursAvg: 36,
    npsScore: 58,
  },
  {
    id: 'c4',
    name: 'Entrepreneurship Lab',
    short: 'Entrepreneur.',
    enrolled: 22,
    pre: 52,
    post: 73,
    final: 79,
    completionPct: 77,
    hoursAvg: 44,
    npsScore: 71,
  },
  {
    id: 'c5',
    name: 'Leadership Elective',
    short: 'Leadership',
    enrolled: 18,
    pre: 60,
    post: 76,
    final: 81,
    completionPct: 83,
    hoursAvg: 31,
    npsScore: 49,
  },
];

const MSDL_COURSES: CourseGrades[] = [
  {
    id: 'd1',
    name: 'Digital Strategy',
    short: 'Strategy',
    enrolled: 12,
    pre: 50,
    post: 68,
    final: 72,
    completionPct: 75,
    hoursAvg: 28,
    npsScore: 38,
  },
  {
    id: 'd2',
    name: 'Data Foundations',
    short: 'Data',
    enrolled: 12,
    pre: 48,
    post: 70,
    final: 74,
    completionPct: 67,
    hoursAvg: 34,
    npsScore: 44,
  },
  {
    id: 'd3',
    name: 'Cloud Platforms',
    short: 'Cloud',
    enrolled: 12,
    pre: 53,
    post: 71,
    final: 75,
    completionPct: 58,
    hoursAvg: 30,
    npsScore: 32,
  },
  {
    id: 'd4',
    name: 'Innovation Sprint',
    short: 'Innovation',
    enrolled: 10,
    pre: 55,
    post: 72,
    final: 77,
    completionPct: 80,
    hoursAvg: 26,
    npsScore: 55,
  },
  {
    id: 'd5',
    name: 'AI for Business',
    short: 'AI',
    enrolled: 10,
    pre: 49,
    post: 67,
    final: 71,
    completionPct: 50,
    hoursAvg: 22,
    npsScore: 28,
  },
];

export const COURSES_BY_PROGRAM: Record<string, CourseGrades[]> = {
  'mba-exec-2024': MBA_COURSES,
  'msdl-2025': MSDL_COURSES,
  'gep-2023': [],
};

// Per-course grade band distribution (%) — distinction / merit / pass / fail, sums to 100
export const COURSE_BAND_PCT: Record<string, [number, number, number, number]> = {
  c1: [38, 44, 14, 4],
  c2: [25, 42, 26, 7],
  c3: [40, 42, 14, 4],
  c4: [27, 43, 24, 6],
  c5: [33, 45, 18, 4],
  d1: [22, 40, 28, 10],
  d2: [24, 41, 27, 8],
  d3: [26, 42, 25, 7],
  d4: [30, 43, 21, 6],
  d5: [20, 38, 30, 12],
};

export const COURSE_BAND_PCT_DEFAULT: [number, number, number, number] = [25, 42, 25, 8];
